import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { PayloadService } from '../payload/payload.service';


import { tap, switchMap } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class BinaService {

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }

    add(phoneNumber): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "bina/add", {
                        "payload": payload,
                        "phone_number": phoneNumber
                    });
                }
            )
        )
    }

    confirm(id, code): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "bina/confirm", {
                        "payload": payload,
                        "id": id,
                        "code": code
                    });
                }
            )
        )
    }

    list(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "bina/list", {
                        "payload": payload
                    });
                }
            )
        )
    }

    delete(id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "bina/delete", {
                        "payload": payload,
                        "id" :id
                    });
                }
            )
        )
    }

    resend(id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "bina/resend", {
                        "payload": payload,
                        "id" :id
                    });
                }
            )
        )
    }
}
